<template>
  <div id="cashierOrderVipIfm">
    <div class="rc-title flex-between alignCenter">
      <div class="center back" @click="back(false)">
        <span style="margin-right:7px;">
          <img src="../../assets/icon/turnLeft.png" alt />
        </span>会员信息
      </div>
      <div class="back" @click="back" style="  color: gray;font-size: 20px;">X</div>
    </div>
    <div class="vipCoent">
      <div class="title">会员卡</div>
      <div class="flex-between alignCenter">
        <div>
          {{vipList.cardName}} {{vipList.discount * 10}}折
          <span
            style="color:#666"
          >{{vipList.phoneNum}}</span>
        </div>
        <div>
          我的余额(元):
          <span
            style="color:#333333;font-weight:bold"
            v-if="vipList.wallet || vipList.wallet == 0"
          >{{vipList.wallet.toFixed(2)}}</span>
        </div>
        <div>
          <el-button size="small" type="primary" plain @click="jump('vipRecharge')">充值会员</el-button>
          <el-button size="small" style="margin-right:10px" type="primary" @click="useCard">使用会员卡</el-button>
          <el-popover
            placement="top-start"
            title
            width="200"
            trigger="click"
            content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
          >
            <div class="center column">
              <div class="popIcon">
                <img src="../../assets/icon/gzhewm.jpg" alt />
              </div>
              <div>扫一扫关注公众号</div>
            </div>

            <el-button size="small" type="primary" plain slot="reference">关注公众号</el-button>
          </el-popover>
          <el-button size="small" style="margin-left:10px" @click="back(false)">取消</el-button>
        </div>
      </div>
    </div>
    <div class="title2">优惠券</div>
    <div class>
      <div>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column align="center" prop="title" label="优惠券名称" width="180"></el-table-column>
          <el-table-column align="center" prop label="有效日期">
            <template slot-scope="scope">
              <div>{{scope.row.expireDay }}
                <!-- {{scope.row.title}} -->
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop label="满减">
            <template slot-scope="scope">
              <div class="center">
                <div>{{scope.row.minUsePrice}}元减{{scope.row.price}}元</div>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" prop label="状态">
            <template slot-scope="scope">
              <div class="center" style="font-size:12px">
                <div
                  v-if="scope.row.usedStatus === 1"
                  style=" color:#108EE9;background:#E7F4FD;padding:3px 10px"
                >正常</div>
                <div
                  v-else-if="scope.row.usedStatus === 2"
                  style=" color:#F9151A;background:#FEEDED;padding:3px 10px"
                >正在使用</div>
                <div v-else style=" color:#F9151A;background:#FEEDED;padding:3px 10px">已使用</div>
              </div>
            </template>
          </el-table-column>-->
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="small" @click="useCode(scope.row)">使用优惠券</el-button>
              <!-- <el-button
                type="primary"
                plain
                @click="deleteCashCouponBatch(scope.row.cashCouponBatchOrderId)"
              >删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import {
  shopMemberList,
  findUserCashCoupons,
  deleteCashCouponBatch
} from "../api";
export default {
  data() {
    return {
      visible: false,
      phoneNum: "",
      userList: "",
      shopInformation: "",
      vipList: {},
      tableData: [],
      payList: {
        orderMark: "",
        payMoney: 0,
        giveChange: 0,
        amountReceived: 0,
        phoneNum: "",
        barCode: ""
      }, //支付所需字段
      vipIfm: [],
      orderArr: [], //生成的订单信息
      intervalNum: 0, //循环次数
      intervalStart: false, //开始循环
      payResult: { cartListTotalPrice: 0, cartListDiscounts: 0 }
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    this.phoneNum = this.$route.query.phoneNum;
    this.shopMemberList(this.$route.query.phoneNum);
    this.payList.payMoney = this.$store.state.cartListTotalPrice;
    this.vipIfm = this.$store.state.offers.vipIfm;
    this.payResult.cartListTotalPrice = this.$store.state.cartListTotalPrice;
    this.payResult.cartListDiscounts = this.$store.state.cartListDiscounts;
  },
  methods: {
    // 充值会员
    jump(path) {
      this.$router.push({ path: path, query: { phoneNum: this.phoneNum } });
    },
    //删除优惠券
    deleteCashCouponBatch(cashCouponBatchOrderId) {
      deleteCashCouponBatch({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        cashCouponBatchOrderId: cashCouponBatchOrderId
      })
        .then(res => {
          if (res.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.shopMemberList(this.$route.query.phoneNum);
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    //使用优惠券
    useCode(cashCoupon) {
      console.log(this.$store.state.status, "this.$store.state.status")
      // if (this.$store.state.offers.type == 2) {
      //   this.$message.error("会员卡优惠和整单改价不可以同时使用");
      //   this.$store.state.offers.type = 2;
      //   this.$store.commit("countTotalPrice");
      //   this.$store.commit("countCartListPrice");
      //   this.back('goHome')
      //   return
      // }
      // if (this.$store.state.offers.type == 3) {
      //   this.$message.error("会员卡优惠和整单折扣不可以同时使用");
      //   this.$store.state.offers.type = 3;
      //   this.$store.commit("countTotalPrice");
      //   this.$store.commit("countCartListPrice");
      //   this.back('goHome')
      //   return
      // }
      
      if (this.$store.state.offers.type == 0) {
        this.$store.state.offers.cashCoupon = cashCoupon;
        this.$store.state.offers.type = 1;
        this.$store.commit("countTotalPrice");
        this.$store.commit("countCartListPrice");
        console.log(cashCoupon, this.$store.state.offers);
        this.$message({
          type: "success",
          message: "使用优惠券成功!"
        });
        if (this.$store.state.status == 1) {
          this.$router.push('/cashierOrder/cashierOrderPay')
        } else if (this.$store.state.status == 2) {
          this.back('goHome')
        }
      } else {
        this.$confirm(
        "当前已使用其它优惠,不可与优惠券同时使用 是否使用优惠券?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          this.$store.state.offers.cashCoupon = cashCoupon;
          this.$store.state.offers.type = 1;
          this.$store.commit("countTotalPrice");
          this.$store.commit("countCartListPrice");
          console.log(cashCoupon, this.$store.state.offers);
          this.$message({
            type: "success",
            message: "使用优惠券成功!"
          });
          // this.back('goHome')
          // this.$router.push('/cashierOrder/cashierOrderPay')
          if (this.$store.state.status == 1) {
            this.$router.push('/cashierOrder/cashierOrderPay')
          } else if (this.$store.state.status == 2) {
            this.back('goHome')
          }
        })
        .catch(() => {});
      }
    },
    //使用会员卡
    useCard() {
      console.log(this.$store.state.status, 'this.$store.state.status')
      // if (this.vipList.isExpire == 1) {
      //   this.$message.error("会员卡已过期");
      //   return;
      // } else if (this.vipList.isEnable == 0) {
      //   this.$message.error("会员卡已禁用");
      //   return;
      // }
      // if (this.$store.state.offers.type == 0) {
      //   this.shopMemberList(this.phoneNum);
      //   this.$store.state.offers.vipIfms = this.vipList;
      //   this.$store.commit("countTotalPrice");
      //   this.$store.commit("countCartListPrice");
      //   this.$message({
      //     type:'success',
      //     message:'使用会员卡成功'
      //   })
      //   this.$store.state.offers.type = 4;
      //   if (this.$store.state.status == 1) {
      //     this.$router.push('/cashierOrder/cashierOrderPay')
      //   } else if (this.$store.state.status == 2) {
      //     this.back('goHome')
      //   }
      // } else {
      //   this.$confirm(
      //   "当前已使用其它优惠,不可与会员卡同时使用 是否使用会员卡?",
      //   "提示",
      //   {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning"
      //   }
      // )
      //   .then(() => {
      //     if (this.$store.state.offers.type == 2) {
      //       this.shopMemberList(this.phoneNum);
      //       this.$store.state.offers.vipIfms = this.vipList;
      //       this.$store.state.offers.type = 2;
      //       this.$store.commit("countTotalPrice");
      //       this.$store.commit("countCartListPrice");
      //       this.$message({
      //         type:'success',
      //         message:'使用会员卡成功'
      //       })
      //       // this.back('goHome')
      //       if (this.$store.state.status == 1) {
      //         this.$router.push('/cashierOrder/cashierOrderPay')
      //       } else if (this.$store.state.status == 2) {
      //         this.back('goHome')
      //       }
      //       return
      //     }
      //     if (this.$store.state.offers.type == 3) {
      //       this.shopMemberList(this.phoneNum);
      //       this.$store.state.offers.vipIfms = this.vipList;
      //       this.$store.state.offers.type = 3;
      //       this.$store.commit("countTotalPrice");
      //       this.$store.commit("countCartListPrice");
      //       this.$message({
      //         type:'success',
      //         message:'使用会员卡成功'
      //       })
      //       // this.back('goHome')
      //       if (this.$store.state.status == 1) {
      //         this.$router.push('/cashierOrder/cashierOrderPay')
      //       } else if (this.$store.state.status == 2) {
      //         this.back('goHome')
      //       }
      //       return
      //     }
      //     this.shopMemberList(this.phoneNum);
      //     this.$store.state.offers.vipIfms = this.vipList;
      //     this.$store.state.offers.type = 4;
      //     this.$store.commit("countTotalPrice");
      //     this.$store.commit("countCartListPrice");
      //     this.$message({
      //       type:'success',
      //       message:'使用会员卡成功'
      //     })
      //     if (this.$store.state.status == 1) {
      //       this.$router.push('/cashierOrder/cashierOrderPay')
      //     } else if (this.$store.state.status == 2) {
      //       this.back('goHome')
      //     }
      //   })
      //   .catch(() => {});
      // }
      if (this.$store.state.offers.type == 1) {
        this.$confirm(
          "当前已使用其它优惠,不可与会员卡同时使用 是否使用会员卡?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {
          this.shopMemberList(this.phoneNum);
          this.$store.state.offers.vipIfms = this.vipList;
          this.$store.state.offers.type = 4;
          this.$store.commit("countTotalPrice");
          this.$store.commit("countCartListPrice");
          this.$message({
            type:'success',
            message:'使用会员卡成功'
          })
          // this.back('goHome')
          if (this.$store.state.status == 1) {
            this.$router.push('/cashierOrder/cashierOrderPay')
          } else if (this.$store.state.status == 2) {
            this.back('goHome')
          }
          return
        })
      } else if (this.$store.state.offers.type == 0) {
        this.shopMemberList(this.phoneNum);
        this.$store.state.offers.vipIfms = this.vipList;
        this.$store.state.offers.type = 4;
        this.$store.commit("countTotalPrice");
        this.$store.commit("countCartListPrice");
        this.$message({
          type:'success',
          message:'使用会员卡成功'
        })
        // this.back('goHome')
        if (this.$store.state.status == 1) {
          this.$router.push('/cashierOrder/cashierOrderPay')
        } else if (this.$store.state.status == 2) {
          this.back('goHome')
        }
      }
      if (this.$store.state.offers.type == 2) {
        this.$confirm(
          "当前已使用其它优惠,不可与会员卡同时使用 是否使用会员卡?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
        .then(() => {
          this.shopMemberList(this.phoneNum);
          this.$store.state.offers.vipIfms = this.vipList;
          this.$store.state.offers.type = 2;
          this.$store.commit("countTotalPrice");
          this.$store.commit("countCartListPrice");
          this.$message({
            type:'success',
            message:'使用会员卡成功'
          })
          // this.back('goHome')
          if (this.$store.state.status == 1) {
            this.$router.push('/cashierOrder/cashierOrderPay')
          } else if (this.$store.state.status == 2) {
            this.back('goHome')
          }
          return
        })
      }
      if (this.$store.state.offers.type == 3) {
        this.$confirm(
          "当前已使用其它优惠,不可与会员卡同时使用 是否使用会员卡?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
          )
        .then(() => {
          this.shopMemberList(this.phoneNum);
          this.$store.state.offers.vipIfms = this.vipList;
          this.$store.state.offers.type = 3;
          this.$store.commit("countTotalPrice");
          this.$store.commit("countCartListPrice");
          this.$message({
            type:'success',
            message:'使用会员卡成功'
          })
          // this.back('goHome')
          if (this.$store.state.status == 1) {
            this.$router.push('/cashierOrder/cashierOrderPay')
          } else if (this.$store.state.status == 2) {
            this.back('goHome')
          }
          return
        })
      }
      if (this.vipList.isExpire == 1) {
        this.$message.error("会员卡已过期");
        return;
      } else if (this.vipList.isEnable == 0) {
        this.$message.error("会员卡已禁用");
        return;
      }
      
    },
    searchVip() {
      if (/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNum)) {
        this.shopMemberList(this.phoneNum);
      } else {
        this.$message.error("请输入正确手机号");
      }
    },
    // 优惠券列表
    findUserCashCoupons(customerUserId) {
      findUserCashCoupons({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        customerUserId: customerUserId,
        row: 999,
        pageNo: 1
      })
        .then(res => {
          // console.log(res.data, "获取商品列表");
          if (res.code == 1) {
            this.tableData = res.data
            // var arr = res.data;
            // for (let i in arr) {
            //   if (arr[i].usedStatus == 1) {
            //     // arr.splice(i, 1);
            //     this.tableData.push(arr[i])
            //   }
            // }
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else if (res.code == -1) {
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    shopMemberList(phone11Num) {
      shopMemberList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        phone11Num: phone11Num
      })
        .then(res => {
          // console.log(res.data, "获取商品列表");
          if (res.code == 1) {
            this.vipList = res.data[0];
            this.findUserCashCoupons(res.data[0].customerUserId);
            this.$store.state.offers.vipIfm = this.vipList;
            console.log(this.vipList, 'this.vipList');
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else if (res.code == -1) {
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    back(a) {
      // this.$store.state.offers.vipIfm = []
      if (a) {
        this.$router.push("/cashierOrder/cashierOrderHome");
        return;
      }
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.el-popover {
  padding: 0 !important;
}
.popIcon {
  height: 78px;
  width: 81px;
  /* margin-right: 23px; */
}
.popIcon img {
  height: 100%;
  width: 100%;
}
.popButton {
  margin-top: 19px;
}
.popWrap {
  font-size: 12px;
}
.popText {
  margin-top: 13px;
}
.title2 {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;
  margin-top: 21px;
  margin-left: 16px;
}
.title {
  font-weight: bold;
  margin-bottom: 16px;
}

.vipCoent {
  padding: 20px 13px;
  background: #f0f8fd;
  margin-top: 20px;
  font-size: 14px;
}
.back {
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(16, 142, 233, 1);
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderVipIfm.vue